import { useMemo } from 'react';

import type { CastingMetadata } from './avatarManagement.types';

export type GetDisplay = (value: string) => string;

/**
 * Maps raw metadata enum values to their pretty-printed `display` values.
 * Falls back to the raw value if missing `display`.
 */
const useMetadataDisplay = (metadata: CastingMetadata | null): GetDisplay =>
  useMemo(() => {
    const displays = new Map<string, string>();
    if (metadata) {
      const entries = [
        ...metadata.castingTags.lifestyleScene,
        ...metadata.castingTags.roleArchetype,
        ...metadata.castingTags.energy,
        ...metadata.genders,
        ...metadata.ethnicities,
        ...metadata.attractivenessLevels,
        ...metadata.buildTypes,
        ...metadata.hairColors,
        ...metadata.skinTones
      ];
      entries.forEach(entry => {
        displays.set(entry.value, entry.display);
      });
    }
    return (value: string) => displays.get(value) ?? value;
  }, [metadata]);

export default useMetadataDisplay;
